import React from "react"

export function User(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_324_5026)">
        <path
          d="M6.125 7C7.05326 7 7.9435 6.63125 8.59987 5.97487C9.25625 5.3185 9.625 4.42826 9.625 3.5C9.625 2.57174 9.25625 1.6815 8.59987 1.02513C7.9435 0.368749 7.05326 0 6.125 0C5.19674 0 4.3065 0.368749 3.65013 1.02513C2.99375 1.6815 2.625 2.57174 2.625 3.5C2.625 4.42826 2.99375 5.3185 3.65013 5.97487C4.3065 6.63125 5.19674 7 6.125 7ZM4.87539 8.3125C2.18203 8.3125 0 10.4945 0 13.1879C0 13.6363 0.363672 14 0.812109 14H11.4379C11.8863 14 12.25 13.6363 12.25 13.1879C12.25 10.4945 10.068 8.3125 7.37461 8.3125H4.87539Z"
          fill="#2A7D8C"
        />
      </g>
      <defs>
        <clipPath id="clip0_324_5026">
          <path d="M0 0H12.25V14H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
